import { marked } from "marked";
import sanitizeHtml from "sanitize-html";

/**
 * - Documentation for setting the renderer:
 *   https://marked.js.org/using_pro#renderer
 * - Code for disable auto-linking when there is no protocol in urls was copied and adapted from:
 *   https://github.com/markedjs/marked/issues/882
 */
let renderer = new marked.Renderer();
renderer.link = function (href, title, text) {
    // Don't create a link if this was an auto-generated link with no given title
    let url_string = href.replace(/(^\w+:|^)\/\//, "");
    if (url_string === text && title === undefined) {
        return text;
    }

    // Only interpret links that contain one of the following protocols
    if (!href.startsWith("http://") && !href.startsWith("https://")) {
        return text;
    }

    return `<a href="${ href }">${ text }</a>`;
};
marked.setOptions({ renderer, breaks: true });

export function parseMarkup(markup: string): string {
    // Forcing a cast to string because "parse" can return a Promise if it's configured to do work asynchronously.
    // From their docs:
    // > Will be a Promise of string if async is set to true by any extensions.
    const parsed = <string>marked.parse(markup);
    return sanitizeHtml(parsed, {
        allowedTags: [
            // Basic
            "em", "strong", "code", "a", "br", "span", "p", "b", "hr",
            // Headers
            "h1", "h2", "h3", "h4", "h5", "h6",
            // Lists
            "ul", "ol", "li",
            // Tables
            "table", "thead", "tbody", "tr", "td", "th"
        ],
    });
}
